import { render } from "./FormCustomHTML.vue?vue&type=template&id=2cf4e696"
import script from "./FormCustomHTML.vue?vue&type=script&lang=js"
export * from "./FormCustomHTML.vue?vue&type=script&lang=js"

import "./FormCustomHTML.vue?vue&type=style&index=0&id=2cf4e696&lang=scss"
script.render = render

export default script